import PropTypes from 'prop-types'

import { calcTableProps } from '@aytm/app/stats/page/question-views/cx/lib/table-utils'

import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'

import WordCloud from '@aytm/app/stats/page/question-views/components/word-cloud/WordCloud'
import Table from '@aytm/app/stats/components/data-views/table/components/Table'

// Combo's cloud surface. Unlike the rest of the family the cloud is not alone here: the items
// list of the level the scope points at sits under it, so the drill-down stays reachable from
// the cloud mode. At a leaf there is no level left to list and block.coffee hands the cloud its
// own words table instead -- which is why `components` here is the block's set, not the one
// inside the cloud's own bag.
const WordCloudView = ({ components, wcProps, tableProps }) => (
  <>
    <WordCloud {...wcProps} />
    {isComponentOn(components, 'table') && <Table {...calcTableProps(tableProps || {})} />}
  </>
)

WordCloudView.displayName = 'CxWordCloudView'

WordCloudView.propTypes = {
  components: PropTypes.object,
  wcProps: PropTypes.object,
  tableProps: PropTypes.object
}

export default WordCloudView
